const { h, render, Component } = require('preact');
const SingleActionSSAView = require('../../views/self_service_actions/single_action_ssa')
const {Portal} = require('preact-portal');

class ReturnItemSSA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  openPopup(){
    this.setState({open: true});
  }

  closePopup(){
    this.setState({open: false});
  }

  getReturnItemUrl(groupon){
    return groupon.returnItemUrl;
  }

  getSingleVoucherSSA(){
    let SSADetails = {
      SSAText: I18n.translate("js.modules.support.return_item"),
      UrlForSSA: this.getReturnItemUrl(this.props.orderDetails)
    }
    return (
      <SingleActionSSAView SSADetails = {SSADetails} />
    );
  }

  getSSATable(){
    let SSAList = [];
    let index = 1;
    this.props.orderDetails.groupons.forEach(groupon => {
      let voucherAction;
      if(this.props.isGrouponRedeemed(groupon)){
        voucherAction = I18n.translate("js.modules.support.Redeemed")
      }
      else if(this.props.isGrouponRefunded(groupon)){
        voucherAction = I18n.translate("js.modules.support.refunded")
      }
      else{
        voucherAction = (
          <a href={this.getReturnItemUrl(groupon)} class="btn ssa-button"
             rel="noopener noreferrer" target="_blank"
             data-bhw="web2018_return_item_button_inside_popup">
            {I18n.translate("js.modules.support.return_item")}
          </a>);
      }
      SSAList.push(
        <tr>
          <td>
            {index++}.&nbsp;
            <a href={this.props.elementsForPopup.dealUrl}
               rel="noopener noreferrer" target="_blank"
               data-bhw="web2018_deal_link_in_return_item_popup">
              {this.props.elementsForPopup.dealTitle}
            </a>
          </td>
          <td>
            {voucherAction}
          </td>
        </tr>
      );
    });
    return (<table class="ssa-deal-sub-table"> {SSAList} </table>);
  }

  getMultipleVoucherSSA(){
    return(
      <div class="ssa-holder multi-voucher-ssa">
          <span class="ssa-button btn-invert" data-bhw="web2018_return_multiple_items_button" onClick={this.openPopup}>
            {I18n.translate("js.modules.support.return_all_items")}
          </span>
          { this.state.open && (
            <Portal into="body">
              <div class="popup" data-bhw="web2018_return_multiple_items_popup">
                <div>
                  <span class="icon-x" onClick={this.closePopup} data-bhw="web2018_return_multiple_items_close_button"></span>
                </div>
                <div class="ssa-link-title">
                {I18n.translate("js.modules.support.return_all_items")}
                </div>
                <div class="ssa-description" dangerouslySetInnerHTML={{ __html: I18n.translate("js.modules.web_2018.return_item_description")}}/>
                <table class="ssa-main-table">
                  <tr>
                    <td class="ssa-deal-image-cell">
                      <img class="ssa-deal-image" src={this.props.elementsForPopup.image} alt="Deal Image"/>
                    </td>
                    <td class="ssa-deal-info-cell">
                      {this.props.elementsForPopup.merchantName} <br/>
                      {I18n.translate("js.modules.support.pur")}&nbsp;{this.props.elementsForPopup.purchaseDate}
                    </td>
                    <td class="ssa-deal-sub-table-cell">
                      {this.getSSATable()}
                    </td>
                  </tr>
                </table>
              </div>
              <div class="shadow"></div>
            </Portal>
            )
          }
        </div>
    );
  }

  constructReturnItemSSA(){
    if (this.props.isSingleGrouponPresent){
      return this.getSingleVoucherSSA()
    }
    else
      return this.getMultipleVoucherSSA();
  }

  render() {
    return this.constructReturnItemSSA();
  }
}
module.exports = ReturnItemSSA
